import { Order } from 'store/cart/types';
import { SavedPaymentMethod } from 'store/payment/types';
import { CREDITS } from 'shared/consts/payment-method-types';

/**
 * Returns the payment methods that are actually applicable to the given cart,
 * mirroring what the PaymentMethods component renders:
 * - credit-only booking (total is 0 and items carry a credit price) -> credits only
 * - cart has credit pricing -> all methods (credits allowed alongside the rest)
 * - otherwise -> everything except credits
 *
 * Keeping this in one place ensures the method we submit/select never diverges
 * from the list shown in the UI.
 */
export const getApplicablePaymentMethods = (
  paymentMethods: Array<SavedPaymentMethod> | null | undefined,
  cart: Order | null | undefined,
): Array<SavedPaymentMethod> => {
  const hasCreditPrice = cart?.items?.some(item => item.credit_price);
  const isCreditOnlyBooking = cart?.total_summary?.total === 0 && hasCreditPrice;

  if (isCreditOnlyBooking) {
    return paymentMethods?.filter(method => method.payment_method_type === CREDITS) ?? [];
  }
  if (hasCreditPrice) {
    return paymentMethods ?? [];
  }
  return paymentMethods?.filter(method => method.payment_method_type !== CREDITS) ?? [];
};
